import { useEffect, useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useSeo } from "@/components/feature/Seo";
import { figures } from "@/mocks/figures";
import { faqs } from "@/mocks/faqs";
import Hero from "./components/Hero";
import LatestDynamics from "./components/LatestDynamics";
import FigureWall from "./components/FigureWall";
import Method from "./components/Method";
import Faq from "./components/Faq";
import AboutTeaser from "./components/AboutTeaser";

const origin = "https://focuspeople.example";

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useSeo({
    title: "最新爆料｜新主角·新面孔·新当事人 人物关系追踪",
    description:
      "最新爆料栏目持续追踪每一桩热点背后的新主角、新面孔与新涉事者，通过人物档案梳理当事人角色、关联脉络与最新动态，为你还原爆料全貌。",
    keywords: "最新爆料,新人物,新主角,新面孔,新涉事者,新当事人,人物追踪",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "焦点人物志 · 最新爆料人物追踪",
        url: origin,
        description:
          "专注最新爆料中的人物追踪，以人物档案方式厘清事件背后的新主角、新面孔与新当事人。",
      },
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "焦点人物志",
        url: origin,
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "最新人物档案",
        itemListElement: figures.map((f, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: f.name,
          url: `${origin}/renwu/${f.id}`,
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
    ],
  });

  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main>
        <Hero />
        <LatestDynamics />
        <FigureWall />
        <Method />
        <Faq />
        <AboutTeaser />
      </main>
      <Footer />

      {showTop && (
        <button
          type="button"
          aria-label="返回顶部"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-foreground-950 text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-arrow-up-line text-lg"></i>
        </button>
      )}
    </div>
  );
}